import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurbine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 20.0 10.0 A 5.2 5.2 0.0 1 1 30.0 10.0 L 20.0 40.0 A 5.2 5.2 0.0 1 0 30.0 40.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTurbine;
